import React from "react";
import { Button } from "@mui/material";
import ExcelJS from "exceljs";
import moment from "moment-jalaali";

const AccumulativeExcelDownload = React.memo(({ data = [], name }) => {

    const exportToExcel = async () => {
        if (!data.length) return;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("orders");

        worksheet.columns = [
            { header: "نام محصول", key: "product_title", width: 30 },
            { header: "کد محصول", key: "code", width: 20 },
            { header: "نام برند", key: "brand_title", width: 25 },
            { header: "تعداد", key: "counter", width: 15 },
        ];

        data.forEach((item) => {
            worksheet.addRow({
                product_title: item.product_title,
                code: item.code,
                brand_title: item.brand_title,
                counter: item.counter,
            });
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${name || "export"}_${moment().unix()}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    return (
        <Button variant="contained" onClick={exportToExcel}>
            خروجی اکسل
        </Button>
    );
});

export default AccumulativeExcelDownload;
